import { IconNames } from '@dixa/lib-shared-habla';

import { CustomFieldAttributeType } from 'apis/customFields';

/** Represents various attributes of a custom attribute type. */
export const customAttributeTypeAttributes: Record<
  CustomFieldAttributeType,
  {
    /** The pretty name of the custom attribute type. */
    readonly label: string;
    /** The icon of the custom attribute type. */
    readonly icon: IconNames;
  }
> = {
  text: {
    label: 'Text',
    icon: 'input',
  },
  select: {
    label: 'Select',
    icon: 'dropdown-list',
  },
};
